<template>
  <d-container fluid>
    <d-row>
      <d-col class="main-content ignite" tag="main" lg="12" md="12" sm="12">
        <!-- Content -->
        <slot />
      </d-col>

    </d-row>
  </d-container>
</template>
<style>
.ignite{
    background-color: black;
    color: white;
    text-align: center;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: relative;
    overflow: hidden;
    max-width: 100vw;
    max-height: 100vh;
}

@keyframes logoAnimation {
    0% { filter: brightness(1); }
    100% { filter: brightness(2); }
}    

.logo {
    margin-top:2.0em;
    margin-bottom:1em;
    width: 21.6vh;
    height: auto;
    animation: logoAnimation 1s ease infinite alternate;
}
</style>

<script>

export default {
  name: 'attendance',
  components: {
  },
  data() {
    return {
    };
  },
};
</script>
